import styled from 'styled-components'

export const NetworkingStyle = styled.div`
  height: calc(100vh - 270px);
  padding-top: 100px;
  padding-bottom: 15px;

  #messageList {
    padding-bottom: 52px;
  }

  .colTitle {
    font-size: .8em;
    margin-left: 1em;
    margin-bottom: 1em;
  }

  .pn-member {
    cursor: pointer;
    &:hover {
      background-color: #f5f5f5;
    }
  }
`
